import React from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * What a Finance page shows until it can show its figures: no kindergarten, still loading,
 * invoicing off, or the figures failed. Null once the page can render.
 */
export const scopeGate = (
  t: ReturnType<typeof useTranslation>['t'],
  state: { kindergartenId: string; loading: boolean; invoicingOn: boolean; failed: boolean }
): React.ReactElement | null => {
  if (!state.kindergartenId) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        {t('finance.pickKindergarten')}
      </Alert>
    );
  }
  if (state.loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!state.invoicingOn) {
    return (
      <Alert severity="warning" sx={{ borderRadius: 2 }}>
        {t('finance.invoicingOff')}
      </Alert>
    );
  }
  if (state.failed) {
    return (
      <Alert severity="error" sx={{ borderRadius: 2 }}>
        {t('finance.loadFailed')}
      </Alert>
    );
  }
  return null;
};
